    export const UI = {
    // Page / Layout
    page: "p-6 bg-gray-50 dark:bg-gray-950 min-h-screen space-y-6",
    container: "space-y-6",

    // Cards
    card: "bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-800",
    cardPad: "p-5",
    cardHeader:
        "px-5 py-4 border-b border-gray-100 dark:border-gray-800 flex items-center justify-between gap-2",
    cardContent: "px-5 py-5",

    // Buttons
    btnPrimary:
        "inline-flex items-center justify-center gap-2 rounded-lg bg-blue-600 text-white text-sm font-medium shadow-sm hover:bg-blue-700 transition px-4 py-2.5 " +
        "focus:outline-none focus:ring-2 focus:ring-blue-500/60 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-900",

    btnOutline:
        "inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 dark:border-gray-700 " +
        "bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100 text-sm font-medium " +
        "hover:bg-gray-50 dark:hover:bg-gray-800 transition px-4 py-2.5 " +
        "focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-900",

    btnSmallOutline:
        "inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 dark:border-gray-700 " +
        "bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-200 text-xs font-medium " +
        "hover:bg-gray-50 dark:hover:bg-gray-800 transition px-3 py-2 " +
        "focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-900",

    // Icon button
    iconBtn:
        "h-9 w-9 inline-flex items-center justify-center rounded-lg " +
        "hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-300 " +
        "focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-900",

    // Form controls
    input:
        "w-full px-4 py-2.5 rounded-lg " +
        "bg-gray-100 dark:bg-gray-900 border border-transparent dark:border-gray-700 " +
        "text-gray-900 dark:text-gray-100 placeholder:text-gray-400 dark:placeholder:text-gray-500 " +
        "focus:bg-white dark:focus:bg-gray-950 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 dark:focus:ring-blue-500/30 " +
        "outline-none text-sm",

    select:
        "w-full px-4 py-2.5 rounded-lg " +
        "bg-gray-100 dark:bg-gray-900 border border-transparent dark:border-gray-700 " +
        "text-gray-900 dark:text-gray-100 " +
        "focus:bg-white dark:focus:bg-gray-950 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 dark:focus:ring-blue-500/30 " +
        "outline-none text-sm",

    textarea:
        "w-full px-4 py-2.5 rounded-lg min-h-[110px] resize-none " +
        "bg-gray-100 dark:bg-gray-900 border border-transparent dark:border-gray-700 " +
        "text-gray-900 dark:text-gray-100 placeholder:text-gray-400 dark:placeholder:text-gray-500 " +
        "focus:bg-white dark:focus:bg-gray-950 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 dark:focus:ring-blue-500/30 " +
        "outline-none text-sm",

    // Modal
    modalOverlay:
        "fixed inset-0 z-50 flex items-center justify-center bg-black/40 dark:bg-black/70 p-4",

    modalBox:
        "w-full bg-white dark:bg-gray-900 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-800 overflow-hidden",

    modalHeader:
        "px-5 py-4 border-b border-gray-100 dark:border-gray-800 flex items-center justify-between",

    modalBody: "px-5 py-5",

    modalFooter:
        "px-5 py-4 border-t border-gray-100 dark:border-gray-800 flex items-center justify-end gap-3",
    };
